export default __webpack_public_path__ + "static/mg-trudne-pytania-a11e2c195b6c721bec74784e762d4bf2.png";